module.exports = __webpack_public_path__ + "p2_img3.jpg?12c7c3baa960aa0f3c9c6af9fecbb3ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img3.jpg
// module id = 176
// module chunks = 0